import type {
  DiversificationCategory,
  DiversificationScheme,
} from '@/store/diversificationsApi';

export function getPortfolioDiversificationIsValid(args: {
  selectedCategory: DiversificationScheme | null;
  syntheticGroups: DiversificationCategory[];
  selectedSyntheticGroup: DiversificationCategory | null;
  detailOptions: DiversificationScheme[];
  selectedDetail: DiversificationScheme | null;
}): boolean {
  const {
    selectedCategory,
    syntheticGroups,
    selectedSyntheticGroup,
    detailOptions,
    selectedDetail,
  } = args;

  if (!selectedCategory) return false;
  if (syntheticGroups.length > 0 && !selectedSyntheticGroup) return false;
  if (detailOptions.length > 0 && !selectedDetail) return false;
  return true;
}
